// extracted by mini-css-extract-plugin
export default {"form":"pMJ2ZQPUhoIw0B1OK6YN","wrap":"O6j2WthZv0ugHsyuuAEK","icon":"w5O8nMMbaNeE3JxfjXOC","input":"OdXzopaYXQwNUKSAmDJu"};